import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G fill="#2685F8">
        <Path d="M14.544 9.182l-1.287-1.818a.667.667 0 00-.93-.16l-1.818 1.288a.667.667 0 10.77 1.088l.61-.431c-.131.443-.331.864-.61 1.245A4.026 4.026 0 018 12.061a4.016 4.016 0 01-3.07-1.417.667.667 0 00-1.017.863A5.347 5.347 0 008 13.393c1.712 0 3.34-.827 4.354-2.212.369-.503.634-1.06.808-1.644l.294.415a.666.666 0 101.088-.77zM5.65 6.58a.667.667 0 00-.93-.159l-.608.431c.13-.443.33-.864.609-1.244A4.027 4.027 0 018 3.94c1.187 0 2.306.516 3.07 1.417a.667.667 0 001.017-.863A5.347 5.347 0 008 2.607c-1.712 0-3.34.828-4.355 2.213a5.35 5.35 0 00-.807 1.644l-.294-.415a.666.666 0 10-1.089.77l1.288 1.819a.667.667 0 00.93.16L5.49 7.51a.667.667 0 00.16-.93z" />
      </G>
    </Svg>
  );
}

export default SvgComponent;
